import React from "react";
import EmpowermentTimeline from "@/components/EmpowermentTimeline";
import PageCTA from "@/components/PageCTA";

const ProgramPage = () => (
  <div className="pt-24">
    <EmpowermentTimeline />
    <PageCTA
      heading="Ready to start Phase One?"
      sub="Phase One is the Friction Audit. Ninety seconds. Zero commitment. Real recommendation."
      secondary={{ to: "/case-study", label: "See a Real Deploy" }}
    />
  </div>
);

export default ProgramPage;
